<template>
  <div class="page container-fluid">
    <div class="row no-gutters h-100">
      <b-link
        class="spec-link col-xs-12 col-sm-6 col-md-4"
        v-for="cat in categories"
        :to="{ name: 'Specjalizacja', params: { name: cat.url_slug, prev: cat.prev, next: cat.next} }"
        :key="cat.url_slug"
      >
        <div class="image">
          <img
            class="img-responsive"
            :src="'/assets/specjalnosci_small/' + cat.url_slug +'.jpg'"
            :alt="cat.title"
          >
        </div>
        <div class="description h-100">
          <span class="col align-self-center">{{ cat.title }}</span>
        </div>
      </b-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Specjalizacje",
  data() {
    return {};
  },
  beforeCreate() {
    if (!this.$store.state.spec) {
      this.$store.dispatch("getSpecs");
    }
  },
  created() {},
  computed: {
    categories() {
      return this.$store.state.specs;
    }
  }
};
</script>
<style>
.spec-link {
  position: relative;
  z-index: 3;
  overflow: hidden;
  background: #000;
}
.spec-link .description {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 3;
  color: #e7ecf2;
  font-weight: 500;
  text-align: center;
  padding: 1rem 1rem;
  text-transform: uppercase;
  display: flex;
  font-size: 2.4rem;
}
.spec-link:focus .image,
.spec-link:hover .image {
  opacity: 0.75;
  transform: scale(1.2);
  transition: all 0.5s;
}
.spec-link .image {
  width: 100%;
  position: relative;
  z-index: 2;
  opacity: 0.4;
}
</style>
<style scoped>
.page {
  padding: 0;
  margin: 0;
  overflow: hidden;
}
</style>